partner
<template>
  <Content title="合作的国内外航空公司">
    <div id="partnerCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
      <div class="carousel-inner h-100">
        <div class="carousel-item partner-item active">
          <img src="/images/pages/gp/partner-1.png" class="w-100 letter-cover" alt="" />
        </div>
        <div class="carousel-item partner-item">
          <img src="/images/pages/gp/partner-2.png" class="w-100 letter-cover" alt="" />
        </div>
      </div>
      <a class="carousel-control-prev" href="#partnerCarousel" role="button" data-slide="prev">
        <span class="carousel-preview-btn" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#partnerCarousel" role="button" data-slide="next">
        <span class="carousel-next-btn" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'DesktopPartner',
  components: { Content },
}
</script>

<style lang="scss" scoped>
.partner-item {
  padding-left: 128px;
  padding-right: 128px;
}
</style>
